"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingFacilityIcon = MissingFacilityIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function MissingFacilityIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_5645_25717)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z",
    fill: "#E4F2DE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.85757 7.68848C9.49502 7.68848 10.0118 8.20523 10.0118 8.84268V31.1573C10.0118 31.7948 9.49502 32.3115 8.85757 32.3115C8.22012 32.3115 7.70337 31.7948 7.70337 31.1573V8.84268C7.70337 8.20523 8.22012 7.68848 8.85757 7.68848Z",
    fill: "#048760"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.0912 26.1558C18.7287 26.1558 19.2454 26.6725 19.2454 27.31V31.1573C19.2454 31.7948 18.7287 32.3115 18.0912 32.3115C17.4538 32.3115 16.937 31.7948 16.937 31.1573V27.31C16.937 26.6725 17.4538 26.1558 18.0912 26.1558Z",
    fill: "#048760"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.7334 22.2513C31.184 21.8006 31.9147 21.8008 32.3655 22.2513C32.8159 22.7021 32.8161 23.4328 32.3655 23.8834L29.3312 26.9162L32.3655 29.9505C32.8159 30.4013 32.8161 31.132 32.3655 31.5826C31.9148 32.0329 31.184 32.0329 30.7334 31.5826L27.6991 28.5483L24.6663 31.5826C24.2156 32.0329 23.4848 32.0329 23.0342 31.5826C22.5838 31.132 22.5839 30.4012 23.0342 29.9505L26.067 26.9162L23.0342 23.8834C22.5835 23.4328 22.5838 22.7021 23.0342 22.2513C23.4849 21.8006 24.2155 21.8006 24.6663 22.2513L27.6991 25.2841L30.7334 22.2513Z",
    fill: "#048760"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.0912 16.9221C18.7287 16.9221 19.2454 17.4389 19.2454 18.0763V21.9237C19.2454 22.5611 18.7287 23.0779 18.0912 23.0779C17.4538 23.0779 16.937 22.5611 16.937 21.9237V18.0763C16.937 17.4389 17.4538 16.9221 18.0912 16.9221Z",
    fill: "#048760"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.3249 7.68848C27.9623 7.68848 28.4791 8.20523 28.4791 8.84268V20.3847C28.4791 21.0222 27.9623 21.5389 27.3249 21.5389C26.6874 21.5389 26.1707 21.0222 26.1707 20.3847V8.84268C26.1707 8.20523 26.6874 7.68848 27.3249 7.68848Z",
    fill: "#048760"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.0912 7.68848C18.7287 7.68848 19.2454 8.20523 19.2454 8.84268V12.69C19.2454 13.3275 18.7287 13.8442 18.0912 13.8442C17.4538 13.8442 16.937 13.3275 16.937 12.69V8.84268C16.937 8.20523 17.4538 7.68848 18.0912 7.68848Z",
    fill: "#048760"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_5645_25717"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    fill: "white",
    height: "40",
    width: "40"
  }))));
}